import { render, staticRenderFns } from "./OttWidget.vue?vue&type=template&id=6a1d72cb&scoped=true"
import script from "./OttWidget.vue?vue&type=script&lang=js"
export * from "./OttWidget.vue?vue&type=script&lang=js"
import style0 from "./OttWidget.vue?vue&type=style&index=0&id=6a1d72cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1d72cb",
  null
  
)

export default component.exports